import React, { useState } from 'react';
import { Container, Typography, TextField, Button, MenuItem, Alert, CircularProgress, Box } from '@mui/material';

function CriarGC() {
  const [form, setForm] = useState({
    nome: '', descricao: '', dia_semana: '', horario: '', endereco: '', bairro: ''
  });
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');

  const DIAS = ['domingo', 'segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado'];

  const handleSubmit = async () => {
    if (!form.nome.trim()) { setErro('Nome do GC é obrigatório'); return; }
    setEnviando(true);
    setErro('');
    try {
      const apiBase = process.env.REACT_APP_API_URL || 'https://api.conectachurch.com.br';
      const res = await fetch(`${apiBase}/grupos-crescimento/cadastro-publico`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.detail || 'Erro ao enviar');
      }
      setSucesso('GC enviado para aprovação do pastor!');
      setForm({ nome: '', descricao: '', dia_semana: '', horario: '', endereco: '', bairro: '' });
    } catch (err) {
      setErro(err.message);
    }
    setEnviando(false);
  };

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 2, md: 6 }, px: { xs: 1, md: 2 } }}>
      <Typography variant="h4" sx={{ fontWeight: 800, mb: 1, textAlign: 'center', fontSize: { xs: '1.2rem', md: '1.5rem' } }}>
        Sugerir um Grupo de Crescimento
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4, textAlign: 'center' }}>
        Preencha os dados abaixo para sugerir a criação de um novo GC. O pastor será notificado para aprovação.
      </Typography>

      {sucesso && <Alert severity="success" sx={{ mb: 3 }}>{sucesso}</Alert>}
      {erro && <Alert severity="error" sx={{ mb: 3 }}>{erro}</Alert>}

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField label="Nome do GC" value={form.nome} onChange={e => setForm(f => ({...f, nome: e.target.value}))} fullWidth required />
        <TextField label="Descrição" value={form.descricao} onChange={e => setForm(f => ({...f, descricao: e.target.value}))} fullWidth multiline rows={3} />
        <TextField label="Dia da semana" value={form.dia_semana} onChange={e => setForm(f => ({...f, dia_semana: e.target.value}))} select fullWidth>
          {DIAS.map(d => <MenuItem key={d} value={d}>{d.charAt(0).toUpperCase() + d.slice(1)}</MenuItem>)}
        </TextField>
        <TextField label="Horário" type="time" value={form.horario} onChange={e => setForm(f => ({...f, horario: e.target.value}))} fullWidth InputLabelProps={{ shrink: true }} />
        <TextField label="Endereço" value={form.endereco} onChange={e => setForm(f => ({...f, endereco: e.target.value}))} fullWidth />
        <TextField label="Bairro" value={form.bairro} onChange={e => setForm(f => ({...f, bairro: e.target.value}))} fullWidth />
        <Button variant="contained" size="large" onClick={handleSubmit} disabled={enviando} sx={{ mt: 1 }}>
          {enviando ? <CircularProgress size={24} /> : 'Enviar Sugestão'}
        </Button>
      </Box>
    </Container>
  );
}

export default CriarGC;
